import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { Observable } from 'rxjs';


interface RejectedDealReasonObject {
    dealId: number;
    reason: string;
    comment: string;
}

@Injectable({
  providedIn: 'root'
})
export class RejectedDealReasonService {

  constructor(private http: ApiHttpClient) { }

  post(rejectedDealReasonObject: RejectedDealReasonObject[]): Observable<any>  {
    return this.http.post<any>('/matching/rejected-deal-reasons', rejectedDealReasonObject);
  }
}
